<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "ExpressLayout"
    }
</script>

<style scoped>

</style>
